// extracted by mini-css-extract-plugin
export default {"marginBottom":"ImprintPage_marginBottom__-X3Sb"};